import React, { ComponentPropsWithRef } from 'react'
import { SvgIcon } from '@mui/material'
// @ts-ignore TS2307
type Props = ComponentPropsWithRef<typeof SvgIcon> 
export const FitmeIconSVG = (p: Props) => (
    <SvgIcon {...p}>
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            // width="67px"
            // height="62px"
            viewBox="0 0 67 62"
            // enable-background="new 0 0 67 62"
            fill="none"
            // viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            // xml:space="preserve"
        >
            <g>
                <g>
                    <path
                        fill="#FFFFFF"
                        d="M12.542,0.915c1.905,0,3.208,0.232,4.089,0.511v5.065c-0.744-0.047-1.302-0.138-1.952-0.138
			c-1.535,0-3.254,0.371-3.254,2.834v2.278h5.206v5.624h-5.203v16.778H4.317V17.089H0.318v-5.624h3.996V9.281
			C4.317,2.402,9.197,0.915,12.542,0.915z M20.856,11.462h7.064v22.401h-7.064V11.462L20.856,11.462z"
                    />
                    <path
                        fill="#FFFFFF"
                        d="M48.361,28.196v5.671c-1.023,0.185-2.696,0.369-4.742,0.369c-3.346,0-7.947-0.743-7.947-8.227v-8.922
			h-3.533v-5.624h3.533V4.817h7.111v6.647h5.066v5.624h-5.066v7.435c0,3.298,1.348,3.81,3.113,3.81
			C46.688,28.334,47.711,28.287,48.361,28.196z"
                    />
                    <path
                        fill="#FFFFFF"
                        d="M4.284,39.078h7.111v3.255c0.976-2.231,3.299-3.856,6.415-3.856c3.998,0,6.041,1.769,7.017,4.138
			c1.208-2.419,3.857-4.138,7.158-4.138c6.416,0,7.947,4.416,7.947,9.109v13.896h-7.159V48.889c0-3.113-1.161-4.416-3.349-4.416
			c-2.231,0-3.763,1.256-3.763,5.483v11.526h-7.159V48.842c0-3.113-1.114-4.369-3.301-4.369c-2.275,0-3.81,1.256-3.81,5.483v11.526
			H4.283L4.284,39.078L4.284,39.078z"
                    />
                    <circle fill="#FFFFFF" cx="24.387" cy="5.333" r="4.421" />
                </g>
                <path
                    fill="#FFFFFF"
                    d="M66.68,50.279H54.875v11.803c-6.52,0-11.803-5.285-11.803-11.803c0-6.52,5.285-11.803,11.803-11.803
		S66.68,43.762,66.68,50.279z"
                />
            </g>
        </svg>
    </SvgIcon>
)
